import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem("accessToken") || null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const initializeAuth = async () => {
      const storedToken = localStorage.getItem("accessToken");
      const storedUserId = localStorage.getItem("userId");
      const storedUser = {
        userId: storedUserId ? parseInt(storedUserId, 10) : null, // Parse userId as number
        name: localStorage.getItem("userName"),
        email: localStorage.getItem("userEmail"),
      };

      if (storedToken && storedUserId) {
        setToken(storedToken);
        setUser(storedUser);
      }
      setLoading(false);
    };

    initializeAuth();
  }, []);

  const login = async (newToken, userData) => {
    localStorage.setItem("accessToken", newToken);
    if (userData) {
      localStorage.setItem("userId", userData.userId); // Store numeric userId
      localStorage.setItem("userName", `${userData.first_name} ${userData.last_name}`);
      localStorage.setItem("userEmail", userData.email);
      setUser({
        userId: parseInt(userData.userId, 10), // Ensure userId is a number
        name: `${userData.first_name} ${userData.last_name}`,
        email: userData.email,
      });
    }
    setToken(newToken);
  };

  const logout = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    localStorage.removeItem("userEmail");
    setToken(null);
    setUser(null);
  };

  const value = {
    user,
    token,
    login,
    logout,
    isAuthenticated: !!token,
    loading,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};